// One header for every page: logo, main navigation (active page highlighted), social link.
// Links are plain anchors (full page loads), matching how the rest of the app navigates.

interface NavItem {
	label: string;
	href: string;
	/** True when `path` belongs to this item. Longest-prefix pages must be listed first. */
	active: (path: string) => boolean;
}

export const NAV_ITEMS: NavItem[] = [
	{ label: "Terminal", href: "/", active: (p) => p === "/" || p.startsWith("/terminal") },
	{ label: "Wallets", href: "/wallets", active: (p) => p === "/wallets" || p.startsWith("/wallets/") },
	{ label: "Segments", href: "/segments", active: (p) => p === "/segments" || p.startsWith("/segments/") },
	{ label: "Dashboard", href: "/dashboard", active: (p) => p === "/dashboard" || p.startsWith("/dashboard/") || p.startsWith("/users") },
];

/** Index of the nav item that owns `path`, or -1 (pure, unit-tested). */
export function activeIndex(path: string): number {
	return NAV_ITEMS.findIndex((i) => i.active(path));
}

export function SiteHeader({ path }: { path: string }) {
	const current = activeIndex(path);
	return (
		<header className="sticky top-0 z-40 border-b border-base-content/10 bg-base-100/90 backdrop-blur">
			<div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-1 px-4 py-2 md:px-6">
				<a
					href="/"
					className="font-mono text-sm font-bold tracking-[0.2em] text-primary hover:opacity-80"
					aria-label="PolyGains home"
				>
					◆ POLYGAINS
				</a>
				<nav
					aria-label="Main"
					className="order-3 -mx-1 flex w-full gap-1 overflow-x-auto md:order-none md:mx-0 md:w-auto md:flex-1"
				>
					{NAV_ITEMS.map((item, i) => (
						<a
							key={item.href}
							href={item.href}
							aria-current={i === current ? "page" : undefined}
							className={`whitespace-nowrap rounded px-2.5 py-1 font-mono text-xs transition-colors ${
								i === current
									? "bg-primary/15 font-bold text-primary"
									: "text-base-content/70 hover:bg-base-content/5 hover:text-primary"
							}`}
						>
							{item.label}
						</a>
					))}
				</nav>
				<a
					href="https://x.com/mevtools"
					target="_blank"
					rel="noreferrer"
					className="ml-auto font-mono text-xs text-base-content/60 hover:text-primary"
				>
					@mevtools
				</a>
			</div>
		</header>
	);
}
